import * as R from "ramda";

export const emptyElement = (el) => {
    el.innerHTML = '';
    return el;
};
export const createElement = (type, attrs) => {
    const el = document.createElement(type);

    R.map(R.tap(
        ([name, value]) => el.setAttribute(name, value),
    ), R.toPairs(attrs));

    return el;
};
export const updateElementAttribute = R.curry((attr, updater, el) => {
    el.setAttribute(attr, updater(el.getAttribute(attr)));
    return el;
});
export const setElementAttribute = R.curry((attr, value, el) => updateElementAttribute(attr, R.always(value), el));
export const addElementClass = (cls, el) => updateElementAttribute('class', R.concat(R.__, ` ${cls}`), el);
export const setElementHtml = (el) => (html) => { el.innerHTML = html; return el; };
export const removeElementClass = (cls, el) => updateElementAttribute('class', R.replace(new RegExp(`\\s?${cls}`), ''), el);